module.exports = __webpack_public_path__ + "static/media/xero-connected.38da663a.svg";